import { SxProps, Theme } from '@mui/material';
import { inclusiveGray, inclusiveYellow } from 'shared/utils/inclusiveColors';
import { Color } from 'shared/utils/colors';

/**
 * Circular icon actions on light hover cards (UserCard, InspectionPreviewCard).
 * Hover uses a tinted primary fill + dark icon — same language as ButtonIcon /
 * row hovers — not yellow-on-yellow icon/border (poor contrast on gray[50] cards).
 */
export const iconButtonStyle: SxProps<Theme> = {
  color: Color.black,
  border: '1px solid',
  borderColor: Color.border,
  borderRadius: '50%',
  backgroundColor: 'transparent',
  transition:
    'background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease',
  '&:hover': {
    backgroundColor: Color.primaryOrangeHover,
    borderColor: Color.primaryOrangeDark,
    color: Color.black,
  },
  '&:active': {
    backgroundColor: Color.primaryOrangeActive,
    borderColor: Color.primaryOrangeDark,
  },
  '&.Mui-disabled': {
    color: Color.mutedBlack,
    borderColor: Color.disabledGray,
    backgroundColor: 'transparent',
  },
  cursor: 'pointer',
};

export const copyIconStyle: SxProps<Theme> = {
  opacity: 0,
  transition: 'opacity 0.2s',
  '&:hover': {
    background: 'transparent',
  },
  '& .MuiSvgIcon-root': {
    color: Color.primaryOrangeDark,
    fontSize: '16px',
  },
};

export const mentionUserChipStyle: SxProps<Theme> = {
  cursor: 'pointer',
  px: 1.5,
  height: 40,
  color: 'black',
  backgroundColor: 'primary.main',
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: inclusiveYellow[300],
  },
  '&:focus': {
    backgroundColor: inclusiveYellow[300],
  },
  '&.MuiChip-root': {
    border: 'none',
  },
  '&.MuiChip-root:hover': {
    backgroundColor: inclusiveYellow[300],
  },
  '&.MuiChip-root:focus': {
    backgroundColor: inclusiveYellow[300],
  },
  '& .MuiChip-icon': {
    color: 'black',
  },
};

export const accessErrorMessageBoxStyle: SxProps<Theme> = {
  backgroundColor: inclusiveGray[700],
  borderRadius: 1,
  px: 1.5,
  py: 1,
  mt: 1,
};

export const accessErrorMessageTextStyle: SxProps<Theme> = {
  color: 'white',
};
